import { useSelector } from "react-redux";

import moment from "moment-timezone";

const TrackingHistory = ({ settings, order }) => {
  const { tracking_history: i18n, tracking_form: trackingFormI18n } =
    useSelector((state) => state.i18n);
  const {
    shipping_address: fooAddress,
    tracking_number: trackingNumber,
    name: orderName,
    tracking_company: carrier,
    tracking_detail: logs,
  } = order;
  const {
    general: { dateFormat, timeFormat },
    time_zone,
  } = useSelector((state) => state.settings);

  const { enabled_edd } = useSelector((state) => state.featureSetting);

  let shippingAddress =
    typeof fooAddress === "string" ? JSON.parse(fooAddress) : fooAddress;
  const address = [];
  for (const [key, value] of Object.entries(shippingAddress ?? {})) {
    if (
      ["address1", "address2", "city", "zip", "province", "country"].includes(
        key
      ) &&
      value
    ) {
      address.push(value);
    }
  }
  shippingAddress = address.join(", ");
  const trackingHistory = typeof logs === "string" ? JSON.parse(logs) : logs;
  return (
    <div className="omg-section">
      <div className="omg-section-shipment-info">
        <div className="omg-section__title">{i18n.shipment_information}</div>
        <div className="omg-section__content">
          <div className="omg-section">
            <div className="omg-pair">
              <div className="omg-pair__key">{i18n.shipping_address}</div>
              <div className="omg-pair__value">{shippingAddress}</div>
            </div>
            <div className="omg-pair">
              <div className="omg-pair__key">{i18n.tracking_number}</div>
              <div className="omg-pair__value">{trackingNumber}</div>
            </div>
            <div className="omg-pair">
              <div className="omg-pair__key">{trackingFormI18n.order_id}</div>
              <div className="omg-pair__value">{orderName}</div>
            </div>
            {settings.show.includes("tracking_company") && (
              <div className="omg-pair">
                <div className="omg-pair__key">{i18n.carrier}</div>
                <div className="omg-pair__value">{carrier}</div>
              </div>
            )}
          </div>
        </div>
      </div>
      {trackingHistory &&
      trackingHistory.length &&
      trackingHistory != null &&
      settings.show.includes("tracking_logs") ? (
        <div className="omg-section-shipment-info history">
          <div className="omg-section">
            <div className="omg-section__title">{i18n.shipment_history}</div>
            <div className="omg-section__content">
              <div className="list-logs">
                {trackingHistory.map((log, index) => (
                  <div className="log-item vertical-progress-node" key={index}>
                    <div className="omg-time">
                      <div className="omg-time__major">
                        {moment(log.date_time).format(dateFormat)}
                      </div>
                      <div className="omg-time__minor">
                        {moment(log.date_time).format(timeFormat)}
                      </div>
                    </div>
                    <span className="omg-description">{log.message}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default TrackingHistory;
